// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.schedule-button {\n  width: 95%;\n}\n.v-label {\n  font-size: 12px !important;\n}\n", ""]);
// Exports
module.exports = exports;
